// Broadcast WS topics that anyone viewing sessions on Discover or on
// /posts/:id wants live updates for. Subscribe via useRealtimeSubscription —
// invalidateByType in useRealtimeNotifications already routes each event to
// the right query key, so consumers only need to subscribe.
//
// Must stay in sync with teamplay-ws BroadcastSubscriptionService.VALID_TOPICS
// — anything missing there is silently dropped on the server side.
export const SESSION_BROADCAST_TOPICS = [
  'SESSION_CREATED',
  'SESSION_MEMBER_JOINED',
  'SESSION_MEMBER_LEFT',
  'SESSION_COMPLETED',
  'SESSION_DISCORD_ACTIVATED',
  'POST_CREATED',
  'POST_UPDATED',
  'POST_DELETED',
  'DISCORD_VOICE_MEMBERS_CHANGED',
];

// Entity-scoped topic: everyone viewing a given post subscribes to it so new
// comments (COMMENT_CREATED / COMMENT_REPLY) fan out live to all viewers, not
// just the post author. Kept in sync with teamplay-ws VALID_TOPIC_PREFIXES
// ("POST_COMMENTS:") and the notification POST_COMMENTS_TOPIC recipient.
export const postCommentsTopic = (postId: string): string => `POST_COMMENTS:${postId}`;
